const a = "cdp", l = {
  alerts: {
    clicked: `${a}-alerts--clicked`,
    viewed: `${a}-alerts--viewed`
  },
  header: {
    globalNav: `${a}-global-nav`,
    globalNavCta: `${a}-global-navcta`,
    localNav: `${a}-local-nav`,
    localNavCta: `${a}-local-navcta`,
    utilNav: `${a}-util-nav`
  }
};
export {
  l as CELEBRUS_CLASSES
};
